<div class="card  veh-information main-equipment-outer" [ngClass]="{'equipment-outer': allDriverVehicle.length>0}">
    <div *ngIf="addButton" class="add-outer" >
        <img src="assets/images/add-plus.svg" (click)="addEquipmentInfo()" alt="Add"/>
        <span pButton (click)="addEquipmentInfo()">{{addEquiMsg}}</span>
    </div>
    <form #vehicleForm="ngForm" novalidate class="equipment-table">
        <p-table #dt [value]="allDriverVehicle" dataKey="id" editMode="row"
            [tableStyle]="{ 'min-width': '50rem' }">

            <ng-template pTemplate="body" let-product let-ri="rowIndex">
                <tr [pEditableRow]="product">

                    <td class="vehicle-type">
                        <div class="vic-type custom-veh-img">
                            <img [src]="product.vehicleImage || (product.vehicleType?.vehicleTypeImagePath)" alt="Vehicle type"/>
                            <div class="vic-text">
                                <p>{{spotTypeMsg}}</p>
                                <div class="vehicle-outer">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            <p class="truck-type">{{product.vehicleType?.name}}</p>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>License Number</p>
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        <p class="truck-type">{{product.licenseNumberPlate}}</p>
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>DOT Number </p>
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        <p class="truck-type">{{product.dotNumber}}</p>
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>Trailer Number </p>
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        <p class="truck-type">{{product.trailerNumber}}</p>
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>Company Name</p>
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        <p class="truck-type">{{product?.companyName}}</p>
                                    </ng-template>
                                </p-cellEditor>
                            </div>
                        </div>
                    </td>

                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>Make</p>
                                <div class="common-width">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            <p class="truck-type">{{product.make? product.make:
                                                "&nbsp;"}}</p>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </div>
                        </div>
                    </td>
        
                    <td>
                        <div class="vic-type1">
                            <div class="vic-text">
                                <p>Color</p>
                                <div class="common-width">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            <p class="truck-type">{{product.color? product.color:
                                                "&nbsp;"}}</p>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="action-item">
                            <div class="export-btn">
                                <img (click)="activeItem = product;showData($event,product);menu.toggle($event)"
                                    src="assets/images/dashboard-dot.svg" alt="" />
                            </div>
                        </div>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </form>

</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu></div>